import { render } from "./Picture.vue?vue&type=template&id=875f2378&scoped=true"
const script = {}

import "./Picture.vue?vue&type=style&index=0&id=875f2378&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-875f2378"]])

export default __exports__